import { COMPONENTS } from './tracking';

export const EVENT_NAMES = {
  SOCIAL_LOGIN_FAILED: 'Social Login Failed',
  LOGIN_OPENED: 'Login Opened',
  LOGIN_CLOSED: 'Login Closed',
  LOGIN_BUTTON_CLICKED: 'Login Button Clicked',
  MARKETING_OPT_IN_DISPLAYED: 'Marketing Consent Screen Displayed',
  MARKETING_OPT_IN_CLICKED: 'Marketing Consent Opt in Clicked',
  MARKETING_OPT_OUT_CLICKED: 'Marketing Consent Opt Out Clicked',
  OPT_IN_SUCCESS: 'Marketing Opt In Succeeded',
  OPT_OUT_SUCCESS: 'Marketing Opt Out Succeeded',
  UPDATE_SUBSCRIPTION_ERROR: 'Login Form Update Subscription Error',
  UPDATE_SUBSCRIPTION_TIMEOUT: 'Login Form Update Subscription Timeout',
  READ_SUBSCRIPTION_TIMEOUT: 'Login Form Read Subscription Timeout',
  IS_SUBSCRIBED_ERROR: 'Login Form isSubscribed Error',
  CONSENT_MODAL_SHOWN: 'Login Form Consent Modal Shown',
  CONSENT_MODAL_SUBMIT: 'Login Form Consent Modal Submit',
  CONSENT_MODAL_CLOSED: 'Login Form Consent Modal No Submit',
  CONSENT_MODAL_MISSING_STRINGS: 'Login Form Consent Modal Missing Strings',
  CONSENT_MODAL_NO_MARKET_CONSENT_DATA: 'Login Form Consent Modal Missing Market Consent Data',
  CONSENT_MODAL_ACCEPT_CONSENT_FAILED: 'Login Form Consent Modal Accept Consent Failed',
  REGULATORY_CONSENT_NOT_ENABLED: 'Login Form Regulatory Consent Not Enabled',
  AUTO_PROMPT_STORAGE_WRITE_ERROR: 'Login Form Auto Prompt Storage Write Error',
  AUTO_PROMPT_STORAGE_READ_ERROR: 'Login Form Auto Prompt Storage Read Error',
  LOGIN_SUCCESS: 'Login Success Step Displayed',
};

export const PAGE_FLOW = {
  INTRO: 'INTRO',
  OTP: 'OTP',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  MARKETING_CONSENT: 'MARKETING_CONSENT',
  REGULATORY_CONSENT: 'REGULATORY_CONSENT',
} as const;

export const stringsKeys = [
  'accountDetectionError',
  'ariaLabelBack',
  'ariaLabelClose',
  'introTitle',
  'otpAwaitLabel',
  'otpErrorSendFailure',
  'otpResendLinkLabel',
  'introDivider',
  'introA11yAppleLoginLabel',
  'introA11yFacebookLoginLabel',
  'introA11yGoogleLoginLabel',
  'introA11yPersistentLoginLabel',
  'defaultTitle',
  'defaultSubtitle',
  'emailLabel',
  'emailPlaceholder',
  'emailSubmitButton',
  'emailError',
  'rememberMeText',
  'legalText',
  'verificationTitle',
  'verificationSubtitle',
  'verificationSentNotice',
  'verificationCodeLabel',
  'verificationCodeMissing',
  'verificationSubmitButton',
  'verificationCodeError',
  'optInTitle',
  'optInSubtitle',
  'optInAcceptButton',
  'optInDeclineButton',
  'optInLegalText',
  'successTitle',
  'chinaKoreaConsentTitle',
  'chinaKoreaConsentButton',
  'chinaKoreaConsentError',
  'koreaPrivacyConsent',
  'koreaTermsConsent',
  'chinaSensitiveDataConsent',
  'chinaShareDataConsent',
  'chinaTermsConsent',
  'regulatoryConsentSubtitle',
  'introModalAriaLabel',
  'introA11yTermsOfServiceLabel',
  'introA11yPrivacyPolicyLabel',
  'regulatoryConsentModalAriaLabel',
  'regulatoryConsentModalAriaLabelBack',
] as const;

export const COMPONENT_NAME = COMPONENTS.LOGIN_FORM_GC;
